// Tiny in-memory pub/sub for "the signed-in user's avatar URL just changed."
// Lets the hoisted JudgeShell layout pick up an avatar upload from the profile
// page without prop-drilling or setting up a context.

type Listener = (userId: string, url: string | null) => void;

const listeners = new Set<Listener>();

export function notifyAvatarChanged(userId: string, url: string | null): void {
  for (const fn of listeners) {
    try {
      fn(userId, url);
    } catch {
      // ignore listener errors
    }
  }
}

export function subscribeToAvatarChanges(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
